import { CoursesTemplatesPicker } from "src/components/NewComponents/Creator/ContentPicker/CoursesTemplatesPicker";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

export function CourseTemplatesPickerContainer() {
	return (
		<LayoutWithSearch>
			<CoursesTemplatesPicker />
		</LayoutWithSearch>
	);
}
